/**
 * 获取用户
 */
export const getUserInfo = '/common/getUserInfo';